import axiosInstance from '../common/axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;


const getCoupon = async (id) => {
  const res = await axiosInstance.get(`${backendUrl}/api/coupons/${id}`);
  return res.data;
}; 

const saveCoupon = async (data) => {
  const res = await axiosInstance.post(`${backendUrl}/api/coupons/create`, data);
  return res.data;
};

export const updateCoupon = async (id, data) => {

  const res = await axiosInstance.put(`${backendUrl}/api/coupons/${id}`, data);
  return res.data;
};

 export const fetchCoupon = async () => {
   
     const res = await axiosInstance.get(`${backendUrl}/api/coupons`);
  return res.data;
  };



 export const deleteCoupon = async (id) => {
   const res = await axiosInstance.delete(`${backendUrl}/api/coupons/${id}`);
  return res.data;
  };

export default { getCoupon, saveCoupon, updateCoupon , fetchCoupon,deleteCoupon };